import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';

const CustomLinearProgress = styled(LinearProgress)(({ theme }) => ({
//   height: 10,
//   borderRadius: 5,
//   '&.MuiLinearProgress-colorPrimary': {
//     backgroundColor: '#D3D3D3',
//   },
  '& .MuiLinearProgress-barColorPrimary': {
    backgroundColor: '#485b7c',
  },
}));
export default function ProgessLoader() {
  const [progress, setProgress] = React.useState(0);
  const [buffer, setBuffer] = React.useState(10);

  const progressRef = React.useRef(() => {});
  React.useEffect(() => {
    progressRef.current = () => {
      if (progress > 100) {
        setProgress(0);
        setBuffer(10);
      } else {
        const diff = Math.random() * 10;
        const diff2 = Math.random() * 10;
        setProgress(progress + diff);
        setBuffer(progress + diff + diff2);
      }
    };
  });

  React.useEffect(() => {
    const timer = setInterval(() => {
      progressRef.current();
    }, 100);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    
    <Box sx={{ width: '100%' }}>
      <CustomLinearProgress variant="buffer" value={progress} valueBuffer={buffer} classes='progessBar' />
    </Box>
  );
}